import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Úvod' },
    { path: '/sluzby', label: 'Služby' },
    { path: '/sluzby-detailne', label: 'Služby detailně' },
    { path: '/o-nas', label: 'O nás' },
    { path: '/kontakt', label: 'Kontakt' }
  ];

  const platformButtons = [
    { label: 'PLATFORMA', url: 'https://chat.czechai.io', color: 'bg-black text-white hover:bg-gray-800' },
    { label: 'VIP', url: 'https://vip.czechai.io', color: 'bg-gray-900 text-white hover:bg-black border border-yellow-400/60 hover:border-yellow-400' },
    { label: 'LEADY', url: 'https://leads.czechai.io', color: 'bg-white text-black border border-gray-300 hover:bg-gray-100' },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleNavClick = () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  return (
    <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo + Platform Buttons */}
          <div className="flex items-center gap-3">
            <Link to="/" onClick={handleNavClick} className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/2e0b1e22c1b74afa84b035f494e9bd64/313ed7822867e251d8c65a89c1e7b33e.png"
                alt="CzechAI Logo"
                className="h-8 w-auto object-contain"
              />
            </Link>

            {/* Platform Buttons - Desktop */}
            <div className="hidden md:flex items-center gap-2 ml-2">
              {platformButtons.map((btn) => (
                <a
                  key={btn.label}
                  href={btn.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative rounded-lg marble-glow cursor-pointer"
                >
                  <span className="marble-border-slow" aria-hidden="true"></span>
                  <span className={`relative z-10 flex items-center whitespace-nowrap text-xs font-bold px-3 py-1.5 rounded-lg tracking-wide ${btn.color}`}>
                    {btn.label}
                  </span>
                </a>
              ))}
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={handleNavClick}
                className={`text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === item.path
                    ? 'text-gray-900 font-semibold'
                    : 'text-gray-700 hover:text-gray-900'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Button size="sm">
              <Link to="/kontakt" onClick={handleNavClick} className="text-white">
                Nezávazná konzultace
              </Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="w-6 h-6 flex items-center justify-center cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl text-gray-700`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            {/* Platform Buttons - Mobile */}
            <div className="flex items-center gap-2 mb-4 flex-wrap">
              {platformButtons.map((btn) => (
                <a
                  key={btn.label}
                  href={btn.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative rounded-lg marble-glow cursor-pointer"
                >
                  <span className="marble-border-slow" aria-hidden="true"></span>
                  <span className={`relative z-10 flex items-center whitespace-nowrap text-xs font-bold px-3 py-1.5 rounded-lg tracking-wide ${btn.color}`}>
                    {btn.label}
                  </span>
                </a>
              ))}
            </div>
            <div className="flex flex-col space-y-3">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => {
                    setIsMenuOpen(false);
                    handleNavClick();
                  }}
                  className={`text-sm font-medium transition-colors cursor-pointer px-2 py-1 ${
                    location.pathname === item.path
                      ? 'text-gray-900 font-semibold'
                      : 'text-gray-700 hover:text-gray-900'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <div className="pt-2">
                <Button size="sm" className="w-full">
                  <Link to="/kontakt" onClick={handleNavClick} className="text-white block w-full">
                    Nezávazná konzultace
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
